export const formatScore = (score) => {
  return Math.round(score);
};
